import { Github, Instagram, Linkedin, Twitter } from 'lucide-react';

import { config } from '@/constants/config';

const socialLinks = [
  {
    href: 'https://github.com/ribeirogab',
    icon: Github,
    label: 'GitHub',
  },
  {
    href: 'https://linkedin.com/in/ribeirogab',
    icon: Linkedin,
    label: 'LinkedIn',
  },
  {
    href: 'https://twitter.com/gbr_osr',
    icon: Twitter,
    label: 'Twitter',
  },
  {
    href: 'https://instagram.com/gbr.osr',
    icon: Instagram,
    label: 'Instagram',
  },
];

export function DeveloperCredit() {
  return (
    <div className="space-y-3">
      <a
        href={config.company.websiteUrl}
        target="_blank"
        className="border-border flex w-fit items-center gap-2 rounded-sm border py-1 pr-1 pl-3"
      >
        <span className="text-muted-foreground text-sm">
          Feito por Gabriel Ribeiro
        </span>
        <img
          src="https://github.com/ribeirogab.png"
          alt="Gabriel Ribeiro"
          className="h-7 w-7 rounded-full"
        />
      </a>
      <div className="flex items-center gap-3">
        <span className="text-muted-foreground text-xs">Me siga no</span>
        <div className="flex items-center gap-2">
          {socialLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              <link.icon className="h-4 w-4" />
              <span className="sr-only">{link.label}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
